import { render, staticRenderFns } from "./planNum.vue?vue&type=template&id=5babd9e3&scoped=true&"
import script from "./planNum.vue?vue&type=script&lang=ts&"
export * from "./planNum.vue?vue&type=script&lang=ts&"
import style0 from "./planNum.vue?vue&type=style&index=0&id=5babd9e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babd9e3",
  null
  
)

export default component.exports